export default function () {
  return [
    { key: 'name' }
  ]
}
